import React from 'react';
import { Helmet } from 'react-helmet';


function About() {
  return (
    <div style={{ padding: '2rem', maxWidth: '800px', margin: '0 auto', lineHeight: '1.7' }}>
<Helmet>
  <title>Meshum | Compare Car Prices with Sold Listings</title>
  <meta name="description" content="See what similar cars have sold for nearby. Use Meshum to get price insights before buying your next car." />
</Helmet>
      <h1>About Meshum</h1>
      <p><strong>Meshum</strong> is a data-driven automotive marketplace focused on price transparency and fairness in car buying.</p>

      <h2>Our Mission</h2>
      <p>
        Buying a car shouldn’t feel like a gamble. At Meshum, our mission is to make car pricing more transparent by showing not just what’s for sale — but what’s actually been sold nearby.
      </p>

      <h2>Why Meshum?</h2>
      <ul>
        <li>✔ Compare active listings to real sold prices</li>
        <li>✔ Know if you’re paying fair market value</li>
        <li>✔ Help dealerships build trust with informed buyers</li>
      </ul>

      <h2>Meet the Founder</h2>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginTop: '1rem' }}>
        <img
          src="https://meshumimages.blob.core.windows.net/websiteimages/img_1_1657380764786~2.jpg"
          alt="Founder"
          style={{ width: '100px', borderRadius: '50%', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}
        />
        <div>
          <p style={{ margin: 0 }}><strong>Loresh Persad</strong></p>
          <p style={{ margin: 0 }}>Founder & CEO</p>
        </div>
      </div>

      <h2>Contact Us</h2>
      <p>Have questions or suggestions? Email us at <a href="mailto:hello@meshum.com">hello@meshum.com</a></p>
    </div>
  );
}

export default About;
